import { render, staticRenderFns } from "./EditPermissions.vue?vue&type=template&id=5d31da11&scoped=true"
import script from "./EditPermissions.vue?vue&type=script&lang=js"
export * from "./EditPermissions.vue?vue&type=script&lang=js"
import style0 from "./EditPermissions.vue?vue&type=style&index=0&id=5d31da11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d31da11",
  null
  
)

export default component.exports